import React, { useEffect } from 'react'
import { useQueryLoader } from 'react-relay'
import { SuggestedQuestions_Query } from '__generated__/SuggestedQuestions_Query.graphql'
import Suspense from 'components/Suspense'
import { IUploadedVideo } from 'hooks/video'
import SuggestedQuestions, { SuggestedQuestionsQuery } from '../SuggestedQuestions'

interface IAddVideoAnswersProps {
  onVideoSaved?: (video: IUploadedVideo) => void
}

export default function AddVideoAnswers(props: IAddVideoAnswersProps) {
  const { onVideoSaved } = props
  const [suggestedQuestionsQuery, loadSuggestedQuestions] = useQueryLoader<SuggestedQuestions_Query>(SuggestedQuestionsQuery)

  useEffect(() => loadSuggestedQuestions({}, { fetchPolicy: 'store-and-network' }), [])

  if (!suggestedQuestionsQuery) return null

  // Note: the SuggestedQuestions *element* has to be rendered here, or else it never loads
  return (
    <Suspense>
      <SuggestedQuestions
        preloadedQuery={suggestedQuestionsQuery}
        onVideoSaved={onVideoSaved}
        showSubmenu={false}
        flatCard
      />
    </Suspense>
  )
}
